import { tokensRx } from '../utils/utils';
import { asValidDateOrNull } from '../create/create-ts-date';
function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
export function createParse(parsers) {
    var RX_TOKENS = tokensRx(parsers);
    return function parse(dateStr, template) {
        var tokens = template.match(RX_TOKENS);
        // this regexp cant fail because of "|."
        var parsersFn = [];
        var rxStr = tokens.map(function (token) {
            var parser = parsers[token];
            if (parser) {
                parsersFn.push(parser[1]);
                var regexpPart = parser[0];
                return "(" + regexpPart + ")";
            }
            if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']')
                token = token.substring(1, token.length - 1);
            return escapeRegExp(token);
        }).join('');
        var rx = new RegExp('^' + rxStr + '$', 'i');
        var values = dateStr.match(rx);
        if (!values)
            return null;
        /* NOTE second zero needed to set current timezone */
        var date = new Date(0, 0);
        values.slice(1).forEach(function (value, index) {
            var parserFn = parsersFn[index];
            parserFn(date, value);
        });
        return asValidDateOrNull(date);
    };
}
export function parseOrThrowWrapper(fn) {
    return function parseOrThrow(dateStr, template) {
        var result = fn(dateStr, template);
        if (result === null)
            throw new Error("Failed to parse date \"" + dateStr + "\" by template \"" + template + "\"");
        return result;
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/parse/create-parse.js
// module id = null
// module chunks = 